<template>
    <div>
        <h2>Debug</h2>
        <p>This page is for various debugging of requests SSR and otherwise for development and support.</p>
        <hr class="thick">

        <h3>Simple Signed Records</h3>
        <div class="mb-5">
        <button @click="generateIdentity" class="btn mr-2">
            Generate Identity
        </button>
        <button @click="getAdminCert" class="btn mr-2">
            Get Admin Certificate
        </button>

        <h4>Test Data</h4>
        <p>Send generic test data as an SSR for backend testing</p>
        <input v-model="formURL" class="">
        <button @click="sendTest" class="btn">
            Send Test
        </button>
    </div>
    <div class="mb-5">
        <h4>Account</h4>
        <p>
            Identity: {{ authSsr.identity.publicKey }}<br>
            Account: {{ authSsr.identity.secretKey }}<br>
            Account Recovery Words:
        </p>
        <code>{{ authSsr.identity.words.join(" ") }}</code>
    </div>
    <div class="mb-5">
        <h4>Admin Cert</h4>
        <code>{{ adminCert }}</code>
    </div>
    <hr class="thick">

    <h2>Server</h2>
    <p>The following is use of <code>&lt;Daemon/&gt;</code> Vue component.</p>
    <Daemon :api="'https://inventory.eotl.supply/api/info'" />
    <div class="mb-5"></div>

  </div>
</template>
<script>
import Daemon from "@/components/Daemon"

import { decodeBase64 } from 'tweetnacl-util'
import { ssr } from '@eotl/simple-signed-records'

import { useEotlCore } from '@/store/eotlStore'
import { useAuthSsr } from '@/store/authSsr'

export default {
  components: { Daemon },
  data: function () {
    const store = useEotlCore()
    const authSsr = useAuthSsr()

    return {
      store,
      authSsr,  
      adminCert: 'None',
      formURL: '',
      formData: {
        note: "Hello my name is Franzi. This is just a test.",
        size: "medium",
        weight: "heavy",
        speed: "immediate",
        dest_address: "Torstrasse 120",
        dest_city: "Berlin"
      }
    }
  },
  methods: {
    generateIdentity() {
      console.log('generateIdentity');
    },
    getAdminCert() {
      const record = {};
      const validSeconds = 15778800;
      const secretKey = decodeBase64(this.authSsr.identity.secretKey);
      const publicKey = decodeBase64(this.authSsr.identity.publicKey);

      let signedData = ssr.sign({
        record,
        keypair: {secretKey, publicKey},
        validSeconds,
      });

      const adminCert = btoa(JSON.stringify(signedData))
      this.adminCert = adminCert
      this.authSsr.account.cert = adminCert
    },
    sendTest() {
      const record = this.formData;
      const validSeconds = 15778800;
      let secretKey = decodeBase64(this.authSsr.identity.secretKey);
      let publicKey = decodeBase64(this.authSsr.identity.publicKey);
      console.log(record)

      let postData = ssr.sign({
          record,
          keypair: { secretKey, publicKey },
          validSeconds,
      });

      fetch(this.store.config.api +  '/' + this.formURL, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postData),
      })
        .then(response => response.json())
        .then(data => {
          console.log('sending test succeeded', data);
        })
        .catch(err => {
          console.log('sending test failed', err);
        });
    }
  }
}
</script>
